module.exports = __webpack_public_path__ + "img/UT0378.f4cee507.png";